<template>
  <collapse :active-index="0">
    <collapse-item>
      <template slot="title">
        <div class="row">
          <div class="col">
            <h3 class="mb-0">{{ title }}</h3>
          </div>
        </div>
      </template>

      <observation-form
        v-if="$can('store', 'plot_stage_comments')"
        ref="ObservationForm"
        title=""
        @save="saveComment"
      />

      <hr v-if="comments" />

      <observation-table
        v-if="comments"
        :comments="comments"
        :edit="$can('destroy', 'plot_stage_comments')"
        @delete="deleteComment"
        @edit="editComment"
      />
    </collapse-item>
  </collapse>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';
import ObservationForm from '../Forms/ObservationForm';
import ObservationTable from '../List/ObservationTable';
import plotStageCommentsMixin from '../../../mixins/plotStageCommentsMixin';

export default {
  components: {
    Collapse,
    CollapseItem,
    ObservationForm,
    ObservationTable,
  },

  mixins: [plotStageCommentsMixin],
  props: {
    title: {
      type: String,
      default: 'Observaciones',
    },

    commentableType: {
      type: String,
      required: true,
    },

    commentable: {
      type: Object,
      required: true,
    },

    comments: {
      type: [Array, Boolean],
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped></style>
